import { render, staticRenderFns } from "./UploadAgreement.vue?vue&type=template&id=67ad703e&scoped=true&"
import script from "./UploadAgreement.vue?vue&type=script&lang=ts&"
export * from "./UploadAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./UploadAgreement.vue?vue&type=style&index=0&id=67ad703e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad703e",
  null
  
)

export default component.exports